(function () {
  if (customElements.get('salut-mega-menu')) return;

  class SalutMegaMenu extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.panels = document.querySelector('[data-salut-menu-panels]');
      this.megaSlot = this.querySelector('[data-salut-panels-slot="mega"]');
      this.drawerSlot = document.querySelector('[data-salut-panels-slot="drawer"]');
      this.screens = Array.from(this.querySelectorAll('[data-salut-mega-screen]'));
      this.requests = new Map();
      this.zone = this.closest('sticky-header') || this.parentElement;
      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.closeTimer = null;
      this.packedWidth = 0;

      this.onViewportChange = () => this.place();
      this.onDocumentClick = (event) => this.handleClick(event);
      this.onDocumentOver = (event) => this.handleDocumentOver(event);
      this.onOver = (event) => this.handleOver(event);
      this.onKeydown = (event) => this.handleKeydown(event);
      this.onZoneEnter = () => this.cancelClose();
      this.onZoneLeave = (event) => {
        if (event.pointerType === 'mouse') this.scheduleClose();
      };

      this.desktopQuery.addEventListener('change', this.onViewportChange);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('pointerover', this.onDocumentOver);
      document.addEventListener('keydown', this.onKeydown);
      this.addEventListener('pointerover', this.onOver);
      this.zone.addEventListener('pointerenter', this.onZoneEnter);
      this.zone.addEventListener('pointerleave', this.onZoneLeave);

      if ('ResizeObserver' in window && this.megaSlot) {
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.megaSlot.clientWidth;
          if (width === this.packedWidth) return;
          this.packedWidth = width;
          this.pack();
        });
        this.resizeObserver.observe(this.megaSlot);
      }

      this.place();
    }

    disconnectedCallback() {
      if (!this.bound) return;
      this.bound = false;
      this.cancelClose();
      this.desktopQuery.removeEventListener('change', this.onViewportChange);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('pointerover', this.onDocumentOver);
      document.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('pointerover', this.onOver);
      this.zone.removeEventListener('pointerenter', this.onZoneEnter);
      this.zone.removeEventListener('pointerleave', this.onZoneLeave);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      const canRestore = this.panels && this.drawerSlot && this.drawerSlot.isConnected;
      if (canRestore && this.panels.parentElement === this.megaSlot) this.drawerSlot.append(this.panels);
    }

    get opener() {
      return document.querySelector('[data-salut-mega-open]');
    }

    place() {
      const isDesktop = this.desktopQuery.matches;
      const slot = isDesktop ? this.megaSlot : this.drawerSlot;
      if (this.panels && slot && this.panels.parentElement !== slot) slot.append(this.panels);
      if (!isDesktop) this.close();
    }

    handleClick(event) {
      if (!this.desktopQuery.matches) return;
      const target = event.target;
      const shortcut = target.closest('[data-salut-screen]');
      const screen = shortcut && this.contains(shortcut) && this.screenFor(shortcut.dataset.salutScreen);
      if (screen) {
        event.preventDefault();
        const handle = screen.dataset.salutMegaScreen;
        this.activate(handle);
        const tab = this.querySelector(`[data-salut-mega-tab="${CSS.escape(handle)}"]`);
        if (tab && event.detail === 0) tab.focus({ preventScroll: true });
        return;
      }
      const anchor = target.closest('[data-scroll-to]');
      if (anchor && this.contains(anchor)) {
        this.scrollToAnchor(anchor.dataset.scrollTo);
        return;
      }
      const retry = target.closest('[data-salut-retry]');
      if (retry && this.contains(retry)) {
        const box = retry.closest('[data-salut-mega-screen]');
        if (box) this.loadScreen(box);
        return;
      }
      if (target.closest('[data-salut-mega-open]')) {
        this.toggle(this.firstHandle());
        if (!this.hidden && event.detail === 0) this.focusActiveTab();
        return;
      }
      const tab = target.closest('[data-salut-mega-tab]');
      if (tab && this.contains(tab)) {
        this.activate(tab.dataset.salutMegaTab);
        return;
      }
      if (!this.hidden && !this.contains(target)) this.close();
    }

    handleDocumentOver(event) {
      if (event.pointerType === 'touch' || !this.desktopQuery.matches) return;
      const direct = event.target.closest('[data-salut-mega-category]');
      if (direct) this.open(direct.dataset.salutMegaCategory);
    }

    handleOver(event) {
      const tab = event.target.closest('[data-salut-mega-tab]');
      if (tab && !tab.classList.contains('is-active')) this.activate(tab.dataset.salutMegaTab);
    }

    handleKeydown(event) {
      if (event.key !== 'Escape' || this.hidden) return;
      const returnFocus = this.contains(document.activeElement);
      this.close();
      const opener = this.opener;
      if (returnFocus && opener) opener.focus();
    }

    firstHandle() {
      const handles = new Set(this.screens.map((box) => box.dataset.salutMegaScreen));
      const first = Array.from(this.querySelectorAll('[data-salut-mega-tab]')).find(
        (tab) => !handles.has(tab.dataset.salutMegaTab)
      );
      return first ? first.dataset.salutMegaTab : null;
    }

    screenFor(name) {
      return this.screens.find((box) => box.dataset.screen === name) || null;
    }

    focusActiveTab() {
      const tab = this.querySelector('[data-salut-mega-tab].is-active');
      if (tab) tab.focus({ preventScroll: true });
    }

    toggle(handle) {
      if (this.hidden) this.open(handle);
      else this.close();
    }

    open(handle) {
      if (!handle || !this.querySelector(`[data-salut-mega-tab="${CSS.escape(handle)}"]`)) return;
      this.cancelClose();
      this.hidden = false;
      const opener = this.opener;
      if (opener) opener.setAttribute('aria-expanded', 'true');
      this.activate(handle);
    }

    close() {
      this.cancelClose();
      if (this.hidden) return;
      this.hidden = true;
      const opener = this.opener;
      if (opener) opener.setAttribute('aria-expanded', 'false');
      this.markDirect(null);
    }

    scheduleClose() {
      this.cancelClose();
      if (this.hidden) return;
      this.closeTimer = setTimeout(() => this.close(), 200);
    }

    cancelClose() {
      if (this.closeTimer === null) return;
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }

    markDirect(handle) {
      document.querySelectorAll('[data-salut-mega-category]').forEach((link) => {
        link.setAttribute('aria-expanded', String(link.dataset.salutMegaCategory === handle));
      });
    }

    activate(handle) {
      if (!handle || !this.panels) return;
      this.querySelectorAll('[data-salut-mega-tab]').forEach((tab) => {
        const active = tab.dataset.salutMegaTab === handle;
        tab.classList.toggle('is-active', active);
        if (active) tab.setAttribute('aria-current', 'true');
        else tab.removeAttribute('aria-current');
      });
      let narrow = false;
      this.panels.querySelectorAll('[data-panel]').forEach((panel) => {
        const active = panel.dataset.panel === handle;
        panel.hidden = !active;
        if (active) narrow = Number(panel.dataset.groups) <= 1 && !panel.querySelector('.salut-menu-panel__needs');
      });
      this.screens.forEach((box) => {
        box.hidden = box.dataset.salutMegaScreen !== handle;
        if (!box.hidden) this.loadScreen(box);
      });
      this.classList.toggle('is-narrow', narrow);
      this.markDirect(handle);
      this.pack();
    }

    loadScreen(box) {
      const lazy = window.SalutMmenuLazy;
      if (!lazy || box.dataset.loaded === 'true' || this.requests.has(box)) return;
      const hub = box.querySelector('template[data-salut-mega-hub]');
      box.replaceChildren(this.screenSkeleton());
      if (hub) box.append(hub);
      box.setAttribute('aria-busy', 'true');
      const root = (this.dataset.root || '/').replace(/\/+$/, '');
      const url = root + '/?section_id=' + encodeURIComponent(box.dataset.section);
      const request = lazy
        .fetchSection(url)
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const brands = doc.querySelector('[data-salut-brands-root]');
          return brands ? this.fillBrands(box, doc, brands, url) : this.fillList(box, doc, hub);
        })
        .then(() => {
          box.dataset.loaded = 'true';
        })
        .catch(() => {
          box.replaceChildren(this.screenError());
          if (hub) box.append(hub);
        })
        .finally(() => {
          box.removeAttribute('aria-busy');
          this.requests.delete(box);
        });
      this.requests.set(box, request);
    }

    fillList(box, doc, hub) {
      const list = doc.querySelector('.salut-mmenu-list');
      if (!list || !list.querySelector('.salut-menu-row')) throw new Error('empty');
      list.querySelectorAll('.salut-mmenu__back, .salut-menu-panel__chips').forEach((node) => node.remove());
      list.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      this.addHub(list, hub);
      box.replaceChildren(list);
      if (hub) box.append(hub);
    }

    fillBrands(box, doc, brands, url) {
      const payload = doc.querySelector('[data-salut-brands]');
      if (!payload || !window.SalutMenuBrands) throw new Error('brands');
      brands.querySelectorAll('.salut-mmenu__back').forEach((node) => node.remove());
      box.replaceChildren(brands, payload);
      return window.SalutMenuBrands.mount(box, url, 'SalutMegaBrandLetter-');
    }

    scrollToAnchor(id) {
      const target = document.getElementById(id);
      const scroller = this.querySelector('.salut-mega');
      if (!target || !scroller || !this.contains(target)) return;
      const offset = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
      scroller.scrollBy({ top: offset - 16, behavior: 'smooth' });
    }

    addHub(list, hub) {
      const title = list.querySelector('.salut-mmenu-list__title');
      if (!hub || !title) return;
      const head = document.createElement('div');
      head.className = 'salut-menu-panel__head';
      title.replaceWith(head);
      head.append(title, hub.content.cloneNode(true));
    }

    screenSkeleton() {
      const wrapper = document.createElement('div');
      wrapper.className = 'salut-mega__screen-skeleton';
      wrapper.setAttribute('aria-hidden', 'true');
      for (let index = 0; index < 12; index++) {
        const row = document.createElement('span');
        row.className = 'salut-skeleton';
        wrapper.appendChild(row);
      }
      return wrapper;
    }

    screenError() {
      const box = document.createElement('div');
      box.className = 'salut-mega__screen-error';
      const message = document.createElement('p');
      message.setAttribute('role', 'alert');
      message.textContent = this.dataset.errorText || '';
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'salut-mmenu-error__retry';
      retry.setAttribute('data-salut-retry', '');
      retry.textContent = this.dataset.retryText || '';
      box.append(message, retry);
      return box;
    }

    pack() {
      if (this.hidden || !this.panels) return;
      const panel = this.panels.querySelector('[data-panel]:not([hidden])');
      const container = panel && panel.querySelector('.salut-menu-panel__groups');
      if (!container) return;
      container.classList.remove('is-packed');
      const gap = parseFloat(getComputedStyle(container).columnGap) || 0;
      container.querySelectorAll(':scope > .salut-menu-panel__group').forEach((group) => {
        const span = Math.ceil(group.getBoundingClientRect().height + gap);
        group.style.setProperty('--salut-span', String(span));
      });
      container.classList.add('is-packed');
    }
  }

  customElements.define('salut-mega-menu', SalutMegaMenu);
})();
